export function createOrganization(data) {
    let { createOrganizationRequest, createOrganizationError, createOrganizationResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'create_organization',
        this.createBundle(
            'create_organization',
            { organization: data },
            this.GET,
            createOrganizationRequest,
            createOrganizationResult,
            createOrganizationError
        )
    )
}
